import React from 'react';
import { useIntersectionObserver } from './useIntersectionObserver';
export function DreamSection() {
  const {
    elementRef,
    isVisible
  } = useIntersectionObserver();
  return <section className="bg-navy-light py-16 md:py-24 border-y border-white/5" data-id="element-13">
      <div ref={elementRef} className={`max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-6 text-gray-200 fade-in-section ${isVisible ? 'is-visible' : ''}`} data-id="element-14">
        <p className="text-xl md:text-2xl leading-relaxed" data-id="element-15">
          Imagínate abrir tu correo y ver una notificación del IRS.
        </p>

        <p className="text-xl md:text-2xl leading-relaxed text-gray-400" data-id="element-16">
          No una carta de cobro. No una auditoría.
        </p>

        <p className="text-2xl md:text-3xl font-heading font-bold text-gold-primary text-center py-4" data-id="element-17">
          Un cheque. O un depósito directo.
        </p>

        <p className="text-xl md:text-2xl leading-relaxed" data-id="element-18">
          Dinero que no esperabas. Dinero que pensabas que habías perdido.
          Dinero que siempre fue tuyo.
        </p>

        <p className="text-xl md:text-2xl leading-relaxed" data-id="element-19">
          Y lo mejor: tú lo hiciste posible.
        </p>

        <p className="text-xl md:text-2xl leading-relaxed text-gray-400" data-id="element-20">
          No tu preparador. No un abogado caro.
        </p>

        <p className="text-xl md:text-2xl leading-relaxed font-bold text-white" data-id="element-21">
          Tú — porque tuviste acceso a información que la mayoría nunca verá.
        </p>

        <div className="h-px bg-white/10 my-6" data-id="element-22"></div>

        <p className="text-xl md:text-2xl leading-relaxed" data-id="element-23">
          Eso cambia algo en ti.
        </p>

        <p className="text-xl md:text-2xl leading-relaxed" data-id="element-24">
          Ya no eres el que "no entiende de taxes."
        </p>

        <p className="text-xl md:text-2xl leading-relaxed font-bold text-gold-primary" data-id="element-25">
          Eres el que sabe cómo usar el sistema a su favor — como siempre debió
          haber sido.
        </p>
      </div>
    </section>;
}